import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {RootState} from '@/store/types';
import {auth} from '@/store/auth';
import {config} from '@/store/config';
import {transports} from '@/store/transport';
import {lists} from '@/store/lists';
import {accounts} from '@/store/accounts';
import {userModule} from "@/store/user";
import {smsModule} from "@/store/sms";
import {viberModule} from "@/store/viber";
import {customModule} from "@/store/custom";
import {mailnotifyModule} from "@/store/mailnotify";
import {finance} from "@/store/finance";
import {callModule} from "@/store/call";
import {pushModule} from "@/store/push";
import {emailModule} from "@/store/email";
import {whatsappModule} from "@/store/whatsapp";
import {originators} from "@/store/originators";
import {messageTypes} from "@/store/message_types";
import {reports} from "@/store/reports";
import {template} from "@/store/templates";
import {blacklists} from "@/store/blacklists"
import {addressbooks} from "@/store/addressbooks"
import axios from 'axios';
import router from '@/routes';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  plugins: [(store) => {
    store.subscribeAction((action, state) => {
      axios.defaults.headers["Request-Page"] = router.currentRoute.meta.msgKey;
      axios.defaults.headers["Request-Language"] =
        localStorage.getItem('locale') === 'ru' ? 'RUS' : 'ENG';
    })
  }],
  state: {
    isLoading: false,
    isLoadingDetailStat: false,
  },
  getters: {
    isLoading: state => {
      return state.isLoading;
    },
    isLoadingDetailStat: state => {
      return state.isLoadingDetailStat;
    },
  },
  mutations: {
    setLoading: (state, value) => {
      return state.isLoading = value;
    },
    setLoadingDetailStat: (state, value) => {
      return state.isLoadingDetailStat = value;
    },
  },
  actions: {

  },
  modules: {
    auth,
    config,
    lists,
    accounts,
    transports,
    userModule,
    smsModule,
    pushModule,
    viberModule,
    customModule,
    mailnotifyModule,
    finance,
    callModule,
    emailModule,
    whatsappModule,
    originators,
    messageTypes,
    reports,
    template,
    blacklists,
    addressbooks
  }
};

export default new Vuex.Store<RootState>(store);